import {
  RESET_SELECTED_TEMPLATE_FILE_ITEM_ACTION,
  SELECT_TEMPLATE_FILE_ITEM_ACTION,
  RESET_SELECTED_DESTINATION_FOLDER_ITEM_ACTION,
  SELECT_DESTINATION_FOLDER_ITEM_ACTION
} from './actions.js'

const DEFAULT = {
  currentFile: null,
  currentFolder: null,
  previousFile: null,
  previousFolder: null
}

/**
 * Reducer for selected item in current tree view.
 */
export function selected (state = DEFAULT, action) { // eslint-disable-line
  switch (action.type) {
    case SELECT_TEMPLATE_FILE_ITEM_ACTION: {
      const { currentFile } = state

      return Object.assign({}, state, {
        currentFile: action.item,
        previousFile: currentFile
      })
    }
    case RESET_SELECTED_TEMPLATE_FILE_ITEM_ACTION:
      return { ...state, currentFile: null }

    case SELECT_DESTINATION_FOLDER_ITEM_ACTION: {
      const { currentFolder } = state
      return Object.assign({}, state, {
        currentFolder: action.item,
        previousFolder: currentFolder
      })
    }
    case RESET_SELECTED_DESTINATION_FOLDER_ITEM_ACTION:
      return { ...state, currentFolder: null }
    default:
      return state
  }
}
